var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.graph && _vm.graph.nodes.length
    ? _c("div", { staticClass: "scp-kgnet" }, [
        _c("div", { staticClass: "scp-kgnet-toolbar" }, [
          _c(
            "div",
            { staticClass: "scp-kgnet-legend" },
            _vm._l(_vm.legendItems, function (item) {
              return _c(
                "span",
                { key: item.type, staticClass: "scp-kgnet-legend-item" },
                [
                  _c("i", {
                    staticClass: "scp-kgnet-swatch",
                    style: { background: item.color },
                  }),
                  _vm._v(" " + _vm._s(item.label) + " "),
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "scp-kgnet-controls" }, [
            _vm.weightFilters && _vm.weightFilterControls.length
              ? _c(
                  "div",
                  {
                    staticClass: "scp-kgnet-weights",
                    attrs: { role: "group", "aria-label": "KG weight filters" },
                  },
                  _vm._l(_vm.weightFilterControls, function (ctrl) {
                    return _c(
                      "label",
                      {
                        key: ctrl.type,
                        staticClass: "scp-kgnet-weight-filter",
                      },
                      [
                        _c("span", { staticClass: "scp-kgnet-weight-label" }, [
                          _vm._v(_vm._s(ctrl.label)),
                        ]),
                        _c(
                          "select",
                          {
                            staticClass: "scp-kgnet-weight-select",
                            attrs: {
                              "aria-label": `${ctrl.label} minimum weight`,
                            },
                            domProps: {
                              value: _vm.weightSelectValue(ctrl.type),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onWeightFilterChange(
                                  ctrl.type,
                                  $event.target.value
                                )
                              },
                            },
                          },
                          _vm._l(ctrl.steps, function (step, idx) {
                            return _c(
                              "option",
                              {
                                key: `${ctrl.type}-${idx}`,
                                domProps: { value: String(step) },
                              },
                              [
                                _vm._v(
                                  " ≥ " +
                                    _vm._s(_vm.formatWeightOption(step)) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "scp-kgnet-zoom",
                attrs: { role: "toolbar", "aria-label": "Network graph zoom" },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.zoomLevel,
                      expression: "zoomLevel",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "scp-kgnet-zoom-slider",
                  attrs: {
                    type: "range",
                    min: _vm.zoomMin,
                    max: _vm.zoomMax,
                    step: _vm.zoomStep,
                    "aria-label": "Network graph zoom",
                  },
                  domProps: { value: _vm.zoomLevel },
                  on: {
                    input: _vm.onZoomInput,
                    __r: function ($event) {
                      _vm.zoomLevel = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "scp-kgnet-zoom-fit",
                    attrs: {
                      type: "button",
                      title: "Fit graph",
                      "aria-label": "Fit graph",
                    },
                    on: { click: _vm.fitNetworkView },
                  },
                  [_vm._v(" Fit ")]
                ),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          {
            ref: "canvasWrap",
            staticClass: "scp-kgnet-canvas-wrap",
            on: { pointerleave: _vm.onCanvasPointerLeave },
          },
          [
            _c("div", {
              ref: "container",
              staticClass: "scp-kgnet-canvas",
              attrs: {
                role: "img",
                "aria-label": "Gene, gene set, factor, and trait network",
              },
            }),
            _vm.isHighlightView
              ? _c(
                  "button",
                  {
                    staticClass: "scp-kgnet-back",
                    attrs: {
                      type: "button",
                      title: "Full network",
                      "aria-label": "Full network",
                    },
                    on: { click: _vm.showFullNetwork },
                  },
                  [_vm._v(" ← ")]
                )
              : _vm._e(),
            _vm.hoverTooltip.visible
              ? _c(
                  "div",
                  {
                    staticClass: "scp-kgnet-tooltip",
                    style: _vm.tooltipStyle,
                    attrs: {
                      role: "dialog",
                      "aria-label": _vm.hoverTooltip.label,
                    },
                    on: {
                      pointerenter: _vm.onTooltipEnter,
                      pointerleave: _vm.onTooltipLeave,
                    },
                  },
                  [
                    _c("p", { staticClass: "scp-kgnet-tooltip-label" }, [
                      _vm._v(_vm._s(_vm.hoverTooltip.label)),
                    ]),
                    !_vm.isHighlightView
                      ? _c(
                          "button",
                          {
                            staticClass: "scp-kgnet-tooltip-action",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.onHighlightAction.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_vm._v(" Highlight connected nodes ")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }